/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css } from 'aphrodite';
import { MaterialIcon } from '@blend/enterprise-components';
import { mixins } from '@blend/consumer-components';
import { ConsumerAppConfigContext, useConsumerTheme } from '../../../hooks/useConsumerTheme';

export namespace ParticipantPin {
  export interface Props {
    isDominantSpeaker?: boolean;
  }
}

const generateStyles = (appConfig: ConsumerAppConfigContext) => ({
  pinWrapper: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: 16,
    height: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: appConfig.colors.catalyst,
    ...mixins.borderRadius(2),
  },
  dominantSpeakerPinWrapper: {
    backgroundColor: appConfig.colors.lightGreen,
  },
  iconWrapper: {
    transform: 'rotate(45deg)',
  },
});

export const ParticipantPin: React.FC<ParticipantPin.Props> = ({ isDominantSpeaker }) => {
  const {
    appConfig: { colors },
    styles,
  } = useConsumerTheme(generateStyles);
  return (
    <div
      className={css(styles.pinWrapper, isDominantSpeaker && styles.dominantSpeakerPinWrapper)}
      data-it="ParticipantPin"
    >
      <div className={css(styles.iconWrapper)}>
        <MaterialIcon type="push_pin" size={10} color={colors.white} />
      </div>
    </div>
  );
};
